<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot="menuLeft" slot-scope=""> </template>
      <template slot="menu" slot-scope="scope">
        <el-button
          type="text"
          size="small"
          v-if="permissionList.viewBtn"
          icon="el-icon-view"
          @click="openViewDialog(scope.row, permissionList.auditBtn)"
          >查看
        </el-button>
        <el-button
          type="text"
          size="small"
          v-if="
            scope.row.allotWorkStatus == 3 || scope.row.allotWorkStatus == 5
          "
          icon="el-icon-view"
          @click="openOutDialog(scope.row, permissionList.auditBtn)"
          >办理出库
        </el-button>
      </template>
      <template slot="projectIdSearch">
        <el-select
          v-model="searchForm.projectId"
          placeholder="请选择"
          @change="projectIdChange"
        >
          <el-option
            v-for="item in projectList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="originWarehouseIdSearch">
        <el-select
          v-model="searchForm.originWarehouseId"
          placeholder="调出仓库名称"
          @change="originWarehouseIdChange"
        >
          <el-option
            v-for="item in warehouseList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="applyTime" slot-scope="scope">
        {{ dayjs(scope.row.applyTime).format("YYYY-MM-DD HH:mm:ss") }}
      </template>
      <template slot="requisitionTimeSearch" slot-scope="">
        <el-date-picker
          v-model="valuetime"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
        >
        </el-date-picker>
      </template>
      <template slot="moneySearch" slot-scope="">
        <el-input v-model="money" disabled></el-input>
      </template>
      <template slot="approveUserIdSearch" slot-scope="">
        <avue-input-tree
          default-expand-all
          v-model="searchForm.approveUserId"
          placeholder="申请人"
          type="tree"
          :dic="userlist"
          @change="approveUserIdChange"
        >
        </avue-input-tree>
      </template>
    </avue-crud>
    <recipientsFrom ref="recipientsFrom" @onLoad="onLoad"></recipientsFrom>
  </basic-container>
</template>

<script>
import {
  getDetail,
  getList,
  getUserlist,
} from "@/api/warehouse-allot/warehouse-allot";
import {
  add,
  remove,
  update,
  getPriceSum,
} from "@/api/warehouseRequisition/warehouserequisition";
import { mapGetters } from "vuex";
import recipientsFrom from "../review/from.vue";
import {
  getProjectList,
  getWarehouseList,
  getDict,
} from "@/api/crmedical/warehouse/index.js";
export default {
  components: {
    recipientsFrom,
  },
  data() {
    return {
      form: {},
      valuetime: "",
      query: {},
      money: 0,
      loading: false,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      onloadFlag: false, //为了避免第一次请求必须在projecid赋值后进行
      selectionList: [],
      searchForm: {
        projectId: "",
        warehouseId: "",
        people: "",
      },
      projectList: [], //项目名称
      warehouseList: [], //仓库名称
      statusList: [], //状态
      option: {
        height: "auto",
        calcHeight: 30,
        tip: false,
        addBtn: false,
        searchShow: true,
        searchMenuSpan: 12,
        border: true,
        index: true,
        emptyBtn: true,
        viewBtn: false,
        selection: false,
        dialogClickModal: false,
        column: [
          {
            label: "项目名称",
            prop: "projectId",
            dicUrl: "/api/v4ward/project/getProjectList",
            search: true,
            type: "select",
            searchslot: true,
            dataType: "string",
            dicData: [],
            props: {
              label: "name",
              value: "id",
            },
            value: "",
            rules: [
              {
                required: true,
                message: "请选择项目",
                trigger: "change",
              },
            ],
          },
          {
            label: "调拨单号",
            prop: "allotNo",
            search: true,
          },
          {
            label: "调出仓库名称",
            searchLabelWidth: 100,
            prop: "originWarehouseId",
            search: true,
            searchslot: true,
            hide: true,
            type: "select",
            rules: [
              {
                required: true,
                message: "请选择仓库",
                trigger: "change",
              },
            ],
          },
          {
            label: "调出仓库",
            prop: "originWarehouseName",
            search: false,
          },
          {
            label: "调入仓库",
            prop: "destWarehouseName",
            search: false,
          },

          {
            label: "调出仓库",
            prop: "inwarehouseId",
            search: false,
            hide: true,
            searchslot: true,
            type: "select",
            rules: [
              {
                required: true,
                message: "请选择仓库",
                trigger: "change",
              },
            ],
          },
          {
            label: "调入仓库",
            prop: "outwarehouseId",
            search: false,
            hide: true,
            searchslot: true,
            type: "select",
            rules: [
              {
                required: true,
                message: "请选择仓库",
                trigger: "change",
              },
            ],
          },
          {
            label: "申请人",
            prop: "applyUserName",
          },
          {
            label: "审核人",
            prop: "approveUserName",
          },
          {
            label: "审核人",
            prop: "approveUserId",
            searchslot: true,
            type: "tree",
            hide: true,
            props: {
              label: "keeperName",
              value: "userId",
            },
            search: true,
            rules: [
              {
                required: true,
                message: "请输入领用数",
                trigger: "change",
              },
            ],
          },
          {
            label: "申请时间",
            prop: "requisitionTime",
            search: true,
            hide: true,
            slot: true,
            type: "datetimerange",
            searchslot: true,
            rangeSeparator: "至",
          },
          {
            label: "申请调拨时间",
            prop: "applyTime",
            slot: true,
          },
          {
            label: "原因",
            prop: "approveOpinion",
            overHidden: "true",
          },
          {
            label: "申请总金额",
            hide: true,
            prop: "requisitionAmount",
            rules: [
              {
                required: true,
                message: "请输入货品单价",
                trigger: "change",
              },
            ],
          },
          {
            label: "状态",
            prop: "allotWorkStatus",
            search: true,
            type: "select",
            dataType: "number",
            dicUrl:
              "/api/blade-system/dict/dictionary?code=warehouse_allot_other_work_status ",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            rules: [
              {
                required: true,
                message: "请选择状态",
                trigger: "change",
              },
            ],
          },
          {
            label: "领用单号",
            prop: "requisitionNo2",
            search: false,
            hide: true,
            maxlength: 20,
            showWordLimit: true,
          },
        ],
      },
      data: [],
      userlist: [],
      value: [],
      list: [],
      loading: false,
    };
  },
  created() {
    this.fetchData();
    setTimeout(() => {
      window.onresize = () => {
        this.$refs.crud.$refs.table.doLayout();
      };
    });
    this.$nextTick(() => {
            this.reWrite = true;
            setTimeout(()=>{
              this.$refs.crud.$children[1].$children[2].$el.addEventListener("click", ()=>{
                    
                    if(this.option.height == this.bodyHeight - 390){
                      this.option.height = this.bodyHeight - 280
                    }else{
                      this.option.height = this.bodyHeight - 390;
                    }
                    this.$refs.crud.getTableHeight();
                });
              })
        
        });
    this.option.height = this.bodyHeight - 390;
  },
  computed: {
    ...mapGetters(["permission", "userInfo"]),
    permissionList() {
      return {
        addBtn: this.vaildData(
          this.permission.warehouserequisitionconsumable_add,
          false
        ),
        viewBtn: this.vaildData(
          this.permission.warehouserequisitionconsumable_view,
          true
        ),
        delBtn: this.vaildData(
          this.permission.warehouserequisitionconsumable_delete,
          false
        ),
        editBtn: this.vaildData(
          this.permission.warehouserequisitionconsumable_edit,
          false
        ),
        auditBtn: this.vaildData(
          this.permission.warehouserequisitionconsumable_audit,
          false
        ),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(",");
    },
  },
  methods: {
    projectIdChange(val) {
      console.log(1212);
      this.getWarehouseList();
      this.updateApplyUserList();
    },
    originWarehouseIdChange(val) {
      this.updateApplyUserList();
    },
    updateApplyUserList() {
      if (!this.searchForm.originWarehouseId || !this.searchForm.projectId) {
        this.userlist = [];
        this.$forceUpdate();
        return;
      }
      this.searchForm.approveUserId = "";
      getUserlist({
        warehouseId: this.searchForm.originWarehouseId,
        projectId: this.searchForm.projectId,
      }).then((res) => {
        this.searchForm = Object.assign({}, this.searchForm, {
          approveUserId: "",
        });
        let arr = [];
        res.data.forEach((ele) => {
          arr.push({
            label: ele.keeperName,
            value: ele.userId,
          });
        });
        this.userlist = arr;
        console.log(this.userlist);
      });
    },
    // 跳转出库记录
    jumpOutbound(row) {
      this.$message({
        message: "该功能暂未开放",
        type: "warning",
      });
    },
    // 获取仓库列表
    getWarehouseList() {
      this.searchForm.originWarehouseId = "";
      this.searchForm = Object.assign({}, this.searchForm, {
        originWarehouseId: "",
      });
      getWarehouseList({ projectId: this.searchForm.projectId }).then((res) => {
        this.warehouseList = res.data;
        let warehouseIdColumn = this.findObject(
          this.option.column,
          "originWarehouseId"
        );
        warehouseIdColumn.dicData = this.warehouseList;
        this.searchForm.originWarehouseId =
          this.warehouseList.length > 0 ? this.warehouseList[0].id : "";
        this.onloadFlag = true;
        this.updateApplyUserList();
        this.onLoad();
      });
    },
    async fetchData() {
      this.pageLoading = true;

      let userId = this.userInfo.user_id;

      try {
        //projectList
        const resProjectList = await getProjectList();
        this.projectList = resProjectList.data;

        this.searchForm.projectId = this.projectList[0]
          ? this.projectList[0].id
          : "";

        // warehouseList
        // const resWarehouseList = await getWarehouseList({
        //     projectId: this.searchForm.projectId,
        // });
        // this.warehouseList = resWarehouseList.data;
        // this.searchForm.warehouseId = this.warehouseList[0]? this.warehouseList[0].id: "";
        // this.onloadFlag = true;
        // this.onLoad();
        this.getWarehouseList();
        getUserlist({
          warehouseId: this.searchForm.originWarehouseId,
          projectId: this.searchForm.projectId,
        }).then((res) => {
          if (
            !this.searchForm.originWarehouseId ||
            !this.searchForm.projectId
          ) {
            this.userlist = [];
            this.$forceUpdate();
            return;
          }
          this.searchForm = Object.assign({}, this.searchForm, {
            approveUserId: "",
          });
          let arr = [];
          res.data.forEach((ele, index) => {
            arr.push({
              label: ele.keeperName,
              value: ele.userId,
            });
          });
          this.userlist = arr;
          console.log(this.userlist);
        });
        //type && status
        const dicts = await Promise.all([
          getDict({ code: "warehouse_inbound_type" }),
          getDict({ code: "inbound_status" }),
        ]);
        this.warehouseInboundTypeList = dicts[0].data;
        this.searchForm.type = this.warehouseInboundTypeList[0].dictKey;
        this.inboundStatusList = dicts[1].data;
        this.searchForm.inboundStatus = this.inboundStatusList[0].dictKey;
        //load list
        // this.loadList();
      } catch (err) {
        console.log("err==>", err);
      }
      this.pageLoading = false;
    },
    // 打开申请表单 新增
    applyFor() {
      let dicData = {
        projectIdDictDataList: this.projectList,
        userlist: this.userlist,
      };
      this.$refs.recipientsFrom.openDialog({ type: "add", dicData: dicData });
    },
    // 打开编辑弹窗
    openEditDialog(row) {
      console.log(row);
      let dicData = {
        projectIdDictDataList: this.projectList,
        userlist: this.userlist,
      };
      this.$refs.recipientsFrom.openDialog({
        type: "edit",
        dicData: dicData,
        data: row,
      });
    },
    // 打开查看弹窗
    openViewDialog(row, auditBtn) {
      // console.log(auditBtn)
      // return

      if (row.allotWorkStatus == 2) {
        auditBtn = true;
      }

      let dicData = {
        projectIdDictDataList: this.projectList,
        userlist: this.userlist,
      };
      this.$refs.recipientsFrom.openDialog({
        type: "view",
        dicData: dicData,
        data: row,
        auditBtn: auditBtn,
      });
    },
    openOutDialog(row, auditBtn) {
      // console.log(auditBtn)
      // return

      if (row.allotWorkStatus == 2) {
        auditBtn = true;
      }

      let dicData = {
        projectIdDictDataList: this.projectList,
        userlist: this.userlist,
      };
      this.$refs.recipientsFrom.openDialog({
        type: "out",
        dicData: dicData,
        data: row,
        auditBtn: auditBtn,
      });
    },
    // 申请人模糊搜索
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.options = this.list.filter((item) => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.options = [];
      }
    },
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success("操作成功!");
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success("操作成功!");
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success("操作成功!");
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success("操作成功!");
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (["edit", "view"].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      } else if ("add" === type) {
        this.cleanForm();
      }
      done();
    },
    cleanForm() {
      for (let key in this.form) {
        this.form[key] = null;
      }
    },
    searchReset() {
      console.log("searchReset");
      this.query.allotNo = "";
      this.query.approveUserId = "";
      this.searchForm.allotNo = "";
      this.searchForm.approveUserId = "";
      this.valuetime = "";
      this.query = {};
      this.$refs.crud.toggleSelection();
      this.onLoad();
    },
    searchChange(params, done) {
      console.log("searchChange=====>", params);
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      if (!this.onloadFlag) {
        return;
      }
      if (!this.userlist || this.userlist.length == 0) {
        return;
      }
      page = page || this.page;
      this.query.approveUserId = this.searchForm.approveUserId || "";
      this.query.projectId = this.searchForm.projectId || "";
      this.query.originWarehouseId = this.searchForm.originWarehouseId || "";
      // this.query.requisitionUser = this.searchForm.requisitionUser || '';
      this.query.allotNo = this.query.allotNo || "";

      if (this.valuetime) {
        this.query.beginTime = this.dayjs(this.valuetime[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.query.endTime = this.dayjs(this.valuetime[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
      this.query.viewType = 2; //审核视角
      this.loading = true;
      console.log(this.query);
      getList(
        Object.assign(
          { current: page.currentPage, size: page.pageSize },
          this.query
        )
      ).then(({ data }) => {
        this.page.total = data.total;
        data.records.forEach((ele) => {
          if (ele.userPhone) {
            ele.userNamePhone = ele.userName + "(" + ele.userPhone + ")";
          } else {
            ele.userNamePhone = ele.userName;
          }
        });
        this.data = data.records;
        this.loading = false;
      });
      getPriceSum(
        Object.assign(
          { current: page.currentPage, size: page.pageSize },
          this.query
        )
      ).then((res) => {
        this.money = res.data;
      });
    },
  },
};
</script>

<style  scoped>


::v-deep .avue-form__menu--center{
    text-align: right;
  }
::v-deep   .avue-crud__search .el-form-item--small.el-form-item{
    width: 100%;
  }
</style>
